/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class JsonResponse
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class JsonResponse<T = any> {
  public status!: boolean;
  public message!: string;
  public data!: T;

  public get isSuccess(): boolean {
    return this.status;
  }

  public get isFailed(): boolean {
    return !this.isSuccess;
  }
}
